import { attr } from '@ember-data/model';
import ShModel from './sh-model';

class SupportArticleModel extends ShModel {
  @attr('string') body;
  @attr('string') categoryName;
  @attr('string') htmlUrl;
  @attr('string') name;
  @attr('string') sectionName;
  @attr('string') title;
}

export default SupportArticleModel;
